// ── Service Worker 등록 ───────────────────────────────────────
// production 환경 + HTTPS에서만 활성화. dev에서는 캐싱 방해 방지를 위해 등록 안 함.
//
// V145: 열어 둔 화면도 새 버전을 알아채게
//   예전엔 브라우저 탭·앱을 계속 켜 두면 배포가 돼도 옛 화면이 그대로 돌았다
//   (새 버전 확인은 주소를 새로 열 때만 한다). 고친 기능이 "안 고쳐졌다"로 보이는 원인.
//   → 화면으로 돌아올 때·20분마다 새 버전을 확인하고, 있으면 'semfit-update-ready' 신호를 보낸다.
//     자동 새로고침은 하지 않는다 (작성 중인 발주서 수량이 날아가므로). UpdateBanner가 버튼을 띄운다.

export const UPDATE_EVENT = 'semfit-update-ready';
const CHECK_EVERY_MS = 20 * 60 * 1000;
const MIN_GAP_MS = 60 * 1000;

function announceUpdate() {
  if (typeof window === 'undefined') return;
  if (window.__semfitUpdateReady) return;
  window.__semfitUpdateReady = true;
  try { window.dispatchEvent(new Event(UPDATE_EVENT)); } catch {}
}

export function register() {
  if (
    typeof window === 'undefined' ||
    !('serviceWorker' in navigator) ||
    process.env.NODE_ENV !== 'production'
  ) {
    return;
  }

  window.addEventListener('load', () => {
    const swUrl = '/service-worker.js';
    // 처음 설치(아직 controller 없음)는 '새 버전'이 아니다
    const hadController = !!navigator.serviceWorker.controller;

    navigator.serviceWorker.register(swUrl)
      .then(registration => {
        const watch = (installing) => {
          if (!installing) return;
          installing.onstatechange = () => {
            if (installing.state === 'installed' && navigator.serviceWorker.controller) {
              // 새 버전 준비 완료 → 바로 활성화하고, 화면에 새로고침 버튼을 띄운다
              try { installing.postMessage('SKIP_WAITING'); } catch {}
              console.log('[SW] 새 버전 준비됨');
              announceUpdate();
            }
          };
        };
        // 업데이트 발견 → 새 SW 설치 후 자동 활성화 트리거
        registration.onupdatefound = () => watch(registration.installing);
        // 이미 받아 두고 기다리는 새 버전이 있으면
        if (registration.waiting && navigator.serviceWorker.controller) {
          try { registration.waiting.postMessage('SKIP_WAITING'); } catch {}
          announceUpdate();
        }

        // V145: 켜 둔 화면도 새 버전 확인 — 화면으로 돌아올 때, 인터넷이 다시 될 때, 20분마다
        let last = Date.now();
        const check = () => {
          if (Date.now() - last < MIN_GAP_MS) return;
          last = Date.now();
          try { const p = registration.update(); if (p && p.catch) p.catch(() => {}); } catch {}
        };
        document.addEventListener('visibilitychange', () => { if (document.visibilityState === 'visible') check(); });
        window.addEventListener('online', check);
        setInterval(check, CHECK_EVERY_MS);
      })
      .catch(err => {
        console.warn('[SW] 등록 실패:', err);
      });

    // controllerchange = 새 SW가 활성화됨 → 자동 새로고침은 하지 않고 버튼만 (작성 중인 발주서 보호)
    navigator.serviceWorker.addEventListener('controllerchange', () => {
      if (hadController) announceUpdate();
    });
  });
}

export function unregister() {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.ready
      .then(reg => reg.unregister())
      .catch(e => console.warn('[SW] 해제 실패:', e));
  }
}
